import Axios, { CreateAxiosDefaults } from 'axios';

/*
 * Axios Configuration
 */
const config: CreateAxiosDefaults = {
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: '',
    scope: 'Productores',
    'X-IBM-Client-Id': process.env.REACT_APP_CLIENT_ID,
  },
};

export const api = Axios.create(config);
